var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSliderbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 240,
    viewBox: "0 0 18 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35557 237.153L0.11222 6.11018C0.0505788 2.75392 2.75439 0 6.11121 0H11.8513C15.2225 0 17.932 2.77667 17.8495 6.14688L12.192 237.177C12.1399 239.303 10.4011 241 8.27403 241C6.13762 241 4.3948 239.289 4.35557 237.153Z",
    fill: "url(#paint0_linear_1_21)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_21",
    x1: 9,
    y1: 0,
    x2: 9,
    y2: 241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FFB905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7DFF5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#51FF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34C2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSliderbar);
export default __webpack_public_path__ + "static/media/icon-sliderbar.d8b7f787d4fceded8df85064b9cfb7e4.svg";
export { ForwardRef as ReactComponent };